import { render, staticRenderFns } from "./selectTypePC.vue?vue&type=template&id=32a4483d&scoped=true&"
import script from "./selectTypePC.vue?vue&type=script&lang=js&"
export * from "./selectTypePC.vue?vue&type=script&lang=js&"
import style0 from "./selectTypePC.vue?vue&type=style&index=0&id=32a4483d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a4483d",
  null
  
)

export default component.exports